<p-toast></p-toast>

<div class="cs-page">

  <!-- ===== Page Header ===== -->
  <div class="cs-page-header">
    <div class="cs-page-header-left">
      <h1 class="cs-page-title">{{ template.templateName }}</h1>
      <nav class="cs-breadcrumb">
        <button class="cs-bc-link" type="button" (click)="onAllTemplates()">Templates</button>
        <i class="ri-arrow-right-s-line"></i>
        <span class="cs-bc-current">{{ template.templateName }}</span>
      </nav>
    </div>
    <div class="cs-page-actions">
      <button class="cs-btn-primary" type="button" (click)="openSectionDialog()">
        <i class="ri-add-line"></i>New Section
      </button>
      @if (hideImportTemplateButton) {
        <button class="cs-btn-outline" type="button" (click)="openImportDialog()">
          <i class="ri-arrow-down-circle-line"></i>Import Template
        </button>
      }
      <button class="cs-btn-icon-only" type="button" (click)="showPreviewDialog = true" title="Preview template">
        <i class="ri-eye-line"></i>
      </button>
    </div>
  </div>

  <!-- ===== Info Card ===== -->
  <div class="cs-info-card">
    <div class="cs-info-body">
      <p class="cs-info-name">{{ template.templateName }}</p>
      <p class="cs-info-desc">{{ template.description }}</p>
    </div>
    <span class="cs-info-date">{{ (template.createdAt ?? template.updatedAt) | date:'MMM d, yyyy | h:mm a' }}</span>
  </div>

  <!-- ===== Sections ===== -->
  <div class="cs-sections">

    <!-- Recursive section/subsection template -->
    <ng-template #sectionTpl let-sect="section" let-level="level" let-siblings="siblings" let-siblingIndex="siblingIndex">
      <div class="cs-section" [class.cs-section--expanded]="sect.isExpanded" [class.cs-section--sub]="level > 0">

        <!-- Section header row -->
        <div class="cs-section-hdr" (click)="toggleSection(sect)">
          <button class="cs-toggle-btn" type="button" (click)="$event.stopPropagation(); toggleSection(sect)">
            <i [class]="sect.isExpanded ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
          </button>
          <div class="cs-section-info">
            <span class="cs-section-name">{{ sect.sectionName }}</span>
            @if (sect.description) {
              <span class="cs-section-desc" [class.cs-section-desc--truncated]="!sect.isExpanded" [title]="!sect.isExpanded ? sect.description : null">{{ sect.description }}</span>
            }
          </div>
          <div class="cs-section-acts" (click)="$event.stopPropagation()">
            <button class="cs-icon-btn" type="button" (click)="moveSectionUp(sect, siblings, siblingIndex)" [disabled]="siblingIndex === 0" title="Move up">
              <i class="ri-arrow-up-line"></i>
            </button>
            <button class="cs-icon-btn" type="button" (click)="moveSectionDown(sect, siblings, siblingIndex)" [disabled]="siblingIndex === siblings.length - 1" title="Move down">
              <i class="ri-arrow-down-line"></i>
            </button>
            <button class="cs-icon-btn" type="button" (click)="openEditDialog(sect)" title="Edit section">
              <i class="ri-pencil-line"></i>
            </button>
            <button class="cs-icon-btn cs-icon-btn--danger" type="button" (click)="deleteSection(sect)" title="Delete section">
              <i class="ri-delete-bin-line"></i>
            </button>
          </div>
        </div>

        <!-- Expanded body -->
        @if (sect.isExpanded) {
          <div class="cs-section-body">

            @for (child of getSectionChildren(sect); track $index; let isFirst = $first; let isLast = $last) {
              @if (child.type === 'lineItem') {
                <!-- Line item -->
                <div class="cs-item">
                  <div class="cs-item-info">
                    <span class="cs-item-name">{{ asLineItem(child).name }}</span>
                    <div class="cs-item-meta">
                      <span class="cs-item-meta-lbl">Control Type</span>
                      <span class="cs-item-meta-val">{{ getControlTypeName(asLineItem(child).controlTypeId || 0) }}</span>
                    </div>
                    <div class="cs-item-req">
                      <span class="cs-chk" [class.cs-chk--on]="asLineItem(child).isRequired">
                        @if (asLineItem(child).isRequired) {
                          <i class="ri-check-line"></i>
                        }
                      </span>
                      <span>Required</span>
                    </div>
                  </div>
                  <div class="cs-item-acts">
                    <button class="cs-icon-btn" type="button" (click)="moveChildUp(sect, $index)" [disabled]="isFirst" title="Move up">
                      <i class="ri-arrow-up-line"></i>
                    </button>
                    <button class="cs-icon-btn" type="button" (click)="moveChildDown(sect, $index)" [disabled]="isLast" title="Move down">
                      <i class="ri-arrow-down-line"></i>
                    </button>
                    <button class="cs-icon-btn" type="button" (click)="openEditLineItem(asLineItem(child))" title="Edit item">
                      <i class="ri-pencil-line"></i>
                    </button>
                    <button class="cs-icon-btn cs-icon-btn--danger" type="button" (click)="deleteLineItem(asLineItem(child))" title="Delete item">
                      <i class="ri-delete-bin-line"></i>
                    </button>
                  </div>
                </div>
                <div class="cs-divider"></div>
              } @else {
                <!-- Subsection (recursive) -->
                <ng-container *ngTemplateOutlet="sectionTpl; context: {section: asSubsection(child), level: level + 1, siblings: sect.subsections, siblingIndex: (sect.subsections?.indexOf(asSubsection(child)) ?? -1)}"></ng-container>
              }
            }

            <!-- Section footer -->
            <div class="cs-section-footer">
              <button class="cs-ghost-btn" type="button" (click)="openLineItemDialog(sect)">
                <i class="ri-add-circle-fill"></i>New Item
              </button>
              @if (level === 0) {
                <button class="cs-ghost-btn cs-ghost-btn--muted" type="button" (click)="openSubsectionDialog(sect)">
                  <i class="ri-add-circle-line"></i>Add Subsection
                </button>
                <button class="cs-ghost-btn cs-ghost-btn--muted" type="button" (click)="openImportSubTemplateDialog(sect)">
                  <i class="ri-download-line"></i>Import Sub Template
                </button>
              }
            </div>

          </div>
        }

      </div>
    </ng-template>

    <!-- Render root sections -->
    @for (sect of sections; track $index) {
      <ng-container *ngTemplateOutlet="sectionTpl; context: {section: sect, level: 0, siblings: sections, siblingIndex: $index}"></ng-container>
    }

    <!-- Add Section CTA -->
    <div class="cs-add-section" (click)="openSectionDialog()">
      <button class="cs-ghost-btn" type="button">
        <i class="ri-add-circle-line"></i>New Section
      </button>
    </div>

  </div>
</div>

<!-- ===== Add / Edit Section Dialog ===== -->
<p-dialog
  [header]="isEdit ? 'Edit Section' : (currentParentSectionId ? 'Add Subsection' : 'Add Section')"
  [(visible)]="showSectionDialog"
  [modal]="true"
  styleClass="kansei-dialog"
  [contentStyle]="{ overflow: 'auto' }"
  [style]="{ width: '42rem' }">
  <form [formGroup]="form" (ngSubmit)="saveSection()">
    <div class="grid">
      <div class="col-12">
        <label for="sectionNameInput" class="modal-label">Name <span class="req">*</span></label>
        <input id="sectionNameInput" type="text" pInputText formControlName="sectionName" class="w-full" />
      </div>
      <div class="col-12">
        <label for="sectionDescInput" class="modal-label">Description</label>
        <textarea id="sectionDescInput" pInputTextarea formControlName="description" class="w-full" rows="5"></textarea>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="modal-btn-cancel" (click)="showSectionDialog = false">Cancel</button>
      <button type="submit" class="modal-btn-primary" [disabled]="form.invalid">Save</button>
    </div>
  </form>
</p-dialog>

<!-- ===== Add / Edit Line Item Dialog ===== -->
<p-dialog #lineItemDialog
  [header]="isLineItemEdit ? 'Edit Item' : 'Add Item'"
  [(visible)]="showChecklistDialog"
  (onHide)="resetLineItemForm()"
  (onShow)="lineItemDialog.maximize()"
  [modal]="true"
  [maximizable]="true"
  [contentStyle]="{ overflow: 'auto' }"
  [style]="{ width: '40rem' }">
  <ng-template pTemplate="content">
    <form [formGroup]="lineItemForm">
      <div class="grid">
        <div class="col-12">
          <label for="controlTypeId" class="modal-label">Control Type <span class="req">*</span></label>
          <select id="controlTypeId" formControlName="controlTypeId"
            class="w-full p-3 border-1 border-300 border-round surface-0 text-900">
            @for (option of controlTypeOptions; track $index) {
              <option [value]="option.controlTypeId">{{ option.controlTypeName }}</option>
            }
          </select>
          @if (+lineItemForm.get('controlTypeId')?.value === 22) {
            <small class="block mt-2 font-bold text-red-600">
              Email notifications will be sent to the respective impacted area holders.
            </small>
          }
        </div>
        <div class="col-12 mt-2">
          <label for="checklistName" class="modal-label">Name <span class="req">*</span></label>
          <textarea id="checklistName" class="w-full p-inputtext-lg" rows="5" pInputTextarea
            formControlName="name"></textarea>
        </div>
        @if ((loadingIntegrationAssociations || integrationCategoryOptions.length > 0) && lineItemForm.get('controlTypeId')?.value != 5) {
          <div class="col-12 mt-2">
            <label for="integrationCategory" class="modal-label">Integration Type</label>
            <p-select
              inputId="integrationCategory"
              [(ngModel)]="selectedIntegrationCategory"
              [ngModelOptions]="{ standalone: true }"
              [options]="integrationCategoryOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Select Integration Type"
              styleClass="w-full"
              (onChange)="onIntegrationCategoryChange()">
            </p-select>
          </div>
          <div class="col-12 mt-2">
            <label for="integrationMappingId" class="modal-label">Integration Data Mapping</label>
            <p-select
              inputId="integrationMappingId"
              formControlName="integrationMappingId"
              [options]="filteredIntegrationAssociations"
              [optionLabel]="integrationOptionLabel"
              optionValue="integrationMappingId"
              placeholder="None"
              [showClear]="true"
              [filter]="true"
              [filterBy]="integrationFilterBy"
              [scrollHeight]="'300px'"
              appendTo="body"
              panelStyleClass="integration-map-panel"
              styleClass="w-full">
              <ng-template pTemplate="item" let-mapping>
                <span>{{ getIntegrationAssociationLabel(mapping) }}</span>
              </ng-template>
              <ng-template pTemplate="selectedItem" let-mapping>
                @if (mapping) {
                  <span>{{ getIntegrationAssociationLabel(mapping) }}</span>
                } @else {
                  <span class="text-500">None</span>
                }
              </ng-template>
            </p-select>
            @if (loadingIntegrationAssociations) {
              <small class="text-500">Loading mappings...</small>
            }
          </div>
        }
        @if (lineItemForm.get('controlTypeId')?.value == 1 || lineItemForm.get('controlTypeId')?.value == 2) {
          <div class="col-12 mt-2">
            <label for="defaultText" class="modal-label">Default Text (Optional)</label>
            <textarea id="defaultText" class="w-full p-inputtext-lg" rows="3" pInputTextarea
              formControlName="defaultText" placeholder="Enter default text to pre-fill this field"></textarea>
          </div>
        }
        @if (lineItemForm.get('controlTypeId')?.value == 14) {
          <div class="col-12 mt-2">
            <label for="labelText" class="modal-label">Formatted Label Text</label>
            <p-editor [style]="{ height: '200px' }" formControlName="defaultText">
              <ng-template pTemplate="header">
                <span class="ql-formats">
                  <button type="button" class="ql-bold" aria-label="Bold"></button>
                  <button type="button" class="ql-italic" aria-label="Italic"></button>
                  <button type="button" class="ql-underline" aria-label="Underline"></button>
                </span>
                <span class="ql-formats">
                  <select class="ql-color"></select>
                  <select class="ql-background"></select>
                </span>
                <span class="ql-formats">
                  <button type="button" class="ql-list" value="ordered" aria-label="Ordered List"></button>
                  <button type="button" class="ql-list" value="bullet" aria-label="Bullet List"></button>
                </span>
                <span class="ql-formats">
                  <select class="ql-align"></select>
                </span>
              </ng-template>
            </p-editor>
          </div>
        }
        @if (+lineItemForm.get('controlTypeId')?.value === 8) {
          <div class="col-12 mt-2">
            <label class="modal-label">Reference Images</label>
            <small class="block text-500 mb-2">These images will be shown as guidance when users fill this picture control.</small>
            <input type="file" accept="image/*,.heic,.heif" multiple (change)="onReferenceImagesSelected($event)" />
            @if (referenceImages.length > 0 || pendingReferenceImagePreviews.length > 0) {
              <div class="flex flex-wrap gap-3 mt-3">
                @for (image of referenceImages; track image.id; let idx = $index) {
                  <div class="border-1 border-300 border-round p-2 surface-50" style="width: 140px;">
                    <img [src]="getReferenceImageUrl(image)" [alt]="image.fileName || 'Reference image'"
                      class="w-full border-round mb-2" style="height: 90px; object-fit: cover;" />
                    <div class="text-sm text-700 white-space-nowrap overflow-hidden text-overflow-ellipsis mb-2">{{ image.fileName || image.id }}</div>
                    <button type="button" class="modal-btn-cancel w-full" (click)="removeExistingReferenceImage(idx)">Remove</button>
                  </div>
                }
                @for (preview of pendingReferenceImagePreviews; track preview.objectUrl; let idx = $index) {
                  <div class="border-1 border-dashed border-400 border-round p-2 surface-0" style="width: 140px;">
                    <img [src]="preview.objectUrl" [alt]="preview.fileName"
                      class="w-full border-round mb-2" style="height: 90px; object-fit: cover;" />
                    <div class="text-sm text-700 white-space-nowrap overflow-hidden text-overflow-ellipsis mb-2">{{ preview.fileName }}</div>
                    <button type="button" class="modal-btn-cancel w-full" (click)="removePendingReferenceImage(idx)">Remove</button>
                  </div>
                }
              </div>
            }
          </div>
        }
        @if ([4, 22].includes(+lineItemForm.get('controlTypeId')?.value)) {
          <div class="col-12">
            <label class="modal-label">{{ +lineItemForm.get('controlTypeId')?.value === 22 ? 'Impacted Area Options (Fixed)' : 'Add Options' }}</label>
            @if (+lineItemForm.get('controlTypeId')?.value !== 22) {
              <div class="col-12 flex align-items-center gap-3">
                <label class="modal-label">Option Text</label>
                <input class="p-inputtext-lg" type="text" pInputText [(ngModel)]="optionText" name="optionText"
                  [ngModelOptions]="{ standalone: true }" />
                <p-button label="Add" icon="pi pi-plus" [disabled]="!optionText" (click)="addOptionText()" size="small" />
              </div>
            }
            @if (itemOptionValueList.length > 0) {
              <div class="col-12">
                <label class="modal-label">Options:</label>
                <ul>
                  @for (option of itemOptionValueList; track $index) {
                    <li class="flex justify-content-between align-items-center p-1">
                      <input class="p-inputtext-lg" type="text" pInputText [(ngModel)]="option.valueText"
                        name="optionText" [ngModelOptions]="{ standalone: true }" [readonly]="+lineItemForm.get('controlTypeId')?.value === 22" />
                      @if (+lineItemForm.get('controlTypeId')?.value !== 22) {
                        <p-button icon="pi pi-times" [text]="true" size="small" severity="danger"
                          (click)="removeOptionText($index)" />
                      }
                    </li>
                  }
                </ul>
              </div>
            }
          </div>
        }
        @if (lineItemForm.get('controlTypeId')?.value == 5) {
          <div class="col-12">
            <label class="modal-label">Add Columns (Max 9)</label>
            @if (loadingIntegrationAssociations || integrationCategoryOptions.length > 0) {
              <div class="col-12 flex align-items-center gap-3">
                <input id="columnName" placeholder="Column Name" [(ngModel)]="columnText"
                  [ngModelOptions]="{ standalone: true }" name="columnText" class="w-full p-inputtext-lg"
                  type="text" pInputText />
                <select id="dataTypeId" [(ngModel)]="selectedDataTypeId" [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="onDataTypeChange()" (change)="onDataTypeChange()"
                  class="w-full p-3 border-1 border-300 border-round surface-0 text-900">
                  @for (option of tableDataTypeOptions; track $index) {
                    <option [value]="option.dataTypeId">{{ option.dataTypeName }}</option>
                  }
                </select>
              </div>
              <div class="col-12">
                <label for="columnIntegrationCategory" class="modal-label">Integration Type</label>
                <p-select
                  inputId="columnIntegrationCategory"
                  [(ngModel)]="selectedIntegrationCategory"
                  [ngModelOptions]="{ standalone: true }"
                  [options]="integrationCategoryOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Select Integration Type"
                  styleClass="w-full"
                  (onChange)="onIntegrationCategoryChange()">
                </p-select>
              </div>
              <div class="col-12 flex align-items-center gap-3">
                <p-select
                  inputId="columnIntegrationMappingId"
                  [(ngModel)]="selectedColumnIntegrationMappingId"
                  [ngModelOptions]="{ standalone: true }"
                  name="columnIntegrationMappingId"
                  [options]="filteredIntegrationAssociations"
                  [optionLabel]="integrationOptionLabel"
                  optionValue="integrationMappingId"
                  placeholder="Integration Data Mapping"
                  [showClear]="true"
                  [filter]="true"
                  [filterBy]="integrationFilterBy"
                  [scrollHeight]="'300px'"
                  appendTo="body"
                  panelStyleClass="integration-map-panel"
                  (onChange)="onColumnIntegrationMappingChange()"
                  styleClass="w-full">
                  <ng-template pTemplate="item" let-mapping>
                    <span>{{ getIntegrationAssociationLabel(mapping) }}</span>
                  </ng-template>
                  <ng-template pTemplate="selectedItem" let-mapping>
                    @if (mapping) {
                      <span>{{ getIntegrationAssociationLabel(mapping) }}</span>
                    } @else {
                      <span class="text-500">Integration Data Mapping</span>
                    }
                  </ng-template>
                </p-select>
                <div class="flex align-items-center gap-2">
                  <p-checkbox id="columnIsRequired" binary="true" [(ngModel)]="columnIsRequired"
                    [ngModelOptions]="{ standalone: true }"></p-checkbox>
                  <label for="columnIsRequired" class="font-medium text-900 mb-0">Required</label>
                </div>
                <p-button [label]="editingTableColumn ? 'Update' : 'Add'" [icon]="editingTableColumn ? 'pi pi-check' : 'pi pi-plus'"
                  [disabled]="!columnText || (!editingTableColumn && getVisibleTableColumnCount() >= 9)" (click)="addTableColumn()" />
              </div>
            } @else {
              <div class="col-12 flex align-items-center gap-3">
                <input id="columnName" placeholder="Column Name" [(ngModel)]="columnText"
                  [ngModelOptions]="{ standalone: true }" name="columnText" class="w-full p-inputtext-lg"
                  type="text" pInputText />
                <select id="dataTypeId" [(ngModel)]="selectedDataTypeId" [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="onDataTypeChange()" (change)="onDataTypeChange()"
                  class="w-full p-3 border-1 border-300 border-round surface-0 text-900">
                  @for (option of tableDataTypeOptions; track $index) {
                    <option [value]="option.dataTypeId">{{ option.dataTypeName }}</option>
                  }
                </select>
                <div class="flex align-items-center gap-2">
                  <p-checkbox id="columnIsRequiredNoMap" binary="true" [(ngModel)]="columnIsRequired"
                    [ngModelOptions]="{ standalone: true }"></p-checkbox>
                  <label for="columnIsRequiredNoMap" class="font-medium text-900 mb-0">Required</label>
                </div>
                <p-button [label]="editingTableColumn ? 'Update' : 'Add'" [icon]="editingTableColumn ? 'pi pi-check' : 'pi pi-plus'"
                  [disabled]="!columnText || (!editingTableColumn && getVisibleTableColumnCount() >= 9)" (click)="addTableColumn()" />
              </div>
            }
            @if (shouldShowColumnOptions) {
              <div class="col-12">
                <label class="modal-label">Add Column Options</label>
                <div class="col-12 flex align-items-center gap-3">
                  <label class="modal-label">Option Text</label>
                  <input class="p-inputtext-lg" type="text" pInputText [(ngModel)]="columnOptionText"
                    [ngModelOptions]="{ standalone: true }" />
                  <p-button label="Add" icon="pi pi-plus" [disabled]="!columnOptionText.trim()"
                    (click)="addColumnOption()" size="small" />
                </div>
                @if (columnOptionValueList.length > 0) {
                  <div class="col-12 mt-2">
                    <label class="modal-label">Column Options:</label>
                    <ul class="list-none p-0 m-0">
                      @for (option of columnOptionValueList; track $index) {
                        <li class="flex justify-content-between align-items-center py-1 px-2 surface-100 border-round my-1">
                          <span>{{ option.valueText }}</span>
                          <p-button icon="pi pi-times" [text]="true" size="small" severity="danger"
                            (click)="removeColumnOption($index)" />
                        </li>
                      }
                    </ul>
                  </div>
                }
              </div>
            }
            @if (getVisibleTableColumnCount() > 0) {
              <div class="col-12 mt-2">
                <label class="modal-label">Columns:</label>
                <ul>
                  @for (column of getVisibleTableColumns(); track $index) {
                    <li class="flex justify-content-between align-items-center">
                      <span>{{ column.columnName }} ({{ getTableDataTypeName(column.dataTypeId || 0) }})
                        @if (column.integrationMappingId) {
                          - {{ getIntegrationAssociationLabelById(column.integrationMappingId || null) }}
                        }
                        @if (column.isRequired) {
                          <span class="req">*</span>
                        }
                      </span>
                      <div class="flex align-items-center gap-1">
                        <p-button icon="pi pi-pencil" [text]="true" size="small"
                          (click)="editTableColumn(column)" />
                        <p-button icon="pi pi-times" [text]="true" size="small" severity="danger"
                          (click)="removeTableColumn(column)" />
                      </div>
                    </li>
                  }
                </ul>
              </div>
            }
          </div>
        }

        <!-- Validation Config: TextBox / TextArea -->
        @if ([1, 2].includes(+lineItemForm.get('controlTypeId')?.value)) {
          <div class="col-12">
            <label class="modal-label">Validation Rules</label>
            <div class="grid formgrid row-gap-2">
              <div class="col-6">
                <label class="modal-label">Min Length</label>
                <input type="number" pInputText class="w-full" formControlName="vcMinLength"
                  min="0" placeholder="e.g. 5" />
              </div>
              <div class="col-6">
                <label class="modal-label">Max Length</label>
                <input type="number" pInputText class="w-full" formControlName="vcMaxLength"
                  min="0" placeholder="e.g. 200" />
              </div>
              <div class="col-12">
                <label class="modal-label">Pattern (Regex)</label>
                <input type="text" pInputText class="w-full" formControlName="vcPattern"
                  placeholder="e.g. ^[A-Z]" />
              </div>
              <div class="col-12">
                <label class="modal-label">Pattern Error Message</label>
                <input type="text" pInputText class="w-full" formControlName="vcPatternMessage"
                  placeholder="e.g. Must start with uppercase letter" />
              </div>
            </div>
          </div>
        }

        <!-- Validation Config: Integer / Decimal -->
        @if ([16, 17].includes(+lineItemForm.get('controlTypeId')?.value)) {
          <div class="col-12">
            <label class="modal-label">Validation Rules</label>
            <div class="grid formgrid row-gap-2">
              <div class="col-6">
                <label class="modal-label">Min Value</label>
                <input type="number" pInputText class="w-full" formControlName="vcMin" placeholder="e.g. 0" />
              </div>
              <div class="col-6">
                <label class="modal-label">Max Value</label>
                <input type="number" pInputText class="w-full" formControlName="vcMax" placeholder="e.g. 100" />
              </div>
            </div>
          </div>
        }

        <!-- Validation Config: Picture / Attachment / Signature -->
        @if ([7, 8, 9].includes(+lineItemForm.get('controlTypeId')?.value)) {
          <div class="col-12">
            <label class="modal-label">Validation Rules</label>
            <div class="grid formgrid row-gap-2">
              <div class="col-6">
                <label class="modal-label">Min Files</label>
                <input type="number" pInputText class="w-full" formControlName="vcMinCount"
                  min="0" placeholder="e.g. 1" />
              </div>
              <div class="col-6">
                <label class="modal-label">Max Files</label>
                <input type="number" pInputText class="w-full" formControlName="vcMaxCount"
                  min="0" placeholder="e.g. 5" />
              </div>
            </div>
          </div>
        }

        <!-- Validation Config: DatePicker / DateTimePicker -->
        @if ([6, 19].includes(+lineItemForm.get('controlTypeId')?.value)) {
          <div class="col-12">
            <label class="modal-label">Validation Rules</label>
            <div class="grid formgrid row-gap-2">
              <div class="col-6">
                <label class="modal-label">Min Date (ISO or "today")</label>
                <input type="text" pInputText class="w-full" formControlName="vcMinDate"
                  placeholder="e.g. 2025-01-01 or today" />
              </div>
              <div class="col-6">
                <label class="modal-label">Max Date (ISO or "today")</label>
                <input type="text" pInputText class="w-full" formControlName="vcMaxDate"
                  placeholder="e.g. 2025-12-31 or today" />
              </div>
            </div>
          </div>
        }

        <!-- Validation Config: Select -->
        @if ([4, 22].includes(+lineItemForm.get('controlTypeId')?.value)) {
          <div class="col-12">
            <label class="modal-label">Selection Count Validation</label>
            <div class="grid formgrid row-gap-2">
              <div class="col-6">
                <label class="modal-label">Min Selections</label>
                <input type="number" pInputText class="w-full" formControlName="vcMinSelections"
                  min="0" placeholder="e.g. 1" />
              </div>
              <div class="col-6">
                <label class="modal-label">Max Selections</label>
                <input type="number" pInputText class="w-full" formControlName="vcMaxSelections"
                  min="0" placeholder="e.g. 3" />
              </div>
            </div>
          </div>
        }

        <!-- Validation Config: Table -->
        @if (+lineItemForm.get('controlTypeId')?.value === 5) {
          <div class="col-12">
            <label class="modal-label">Row Count Validation</label>
            <div class="grid formgrid row-gap-2">
              <div class="col-6">
                <label class="modal-label">Min Rows</label>
                <input type="number" pInputText class="w-full" formControlName="vcMinRows"
                  min="0" placeholder="e.g. 1" />
              </div>
              <div class="col-6">
                <label class="modal-label">Max Rows</label>
                <input type="number" pInputText class="w-full" formControlName="vcMaxRows"
                  min="0" placeholder="e.g. 20" />
              </div>
            </div>
          </div>
        }

        <div class="col-12 flex align-items-center gap-3">
          <label for="isRequired" class="modal-label mb-0">Is Required</label>
          <p-checkbox id="isRequired" binary="true" formControlName="isRequired"></p-checkbox>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="modal-footer">
      <button type="button" class="modal-btn-cancel" (click)="showChecklistDialog = false">Cancel</button>
      <button type="button" class="modal-btn-primary" [disabled]="lineItemForm.invalid" (click)="saveLineItem()">Save</button>
    </div>
  </ng-template>
</p-dialog>

<!-- ===== Import Template Dialog ===== -->
<p-dialog
  [(visible)]="showImportTemplateDialog"
  [modal]="true"
  [style]="{ width: '50rem' }"
  [header]="currentImportParentSectionId ? 'Import Sub Templates' : 'Import Templates'">
  <ng-template pTemplate="content">
    <p-multiSelect id="templateSelect" [options]="subTemplateList" [(ngModel)]="selectedTemplateIds"
      optionLabel="templateName" optionValue="templateId" placeholder="Choose templates to assign"
      [showToggleAll]="true" [showHeader]="true" [filter]="true" filterBy="templateName"
      [style]="{ width: '100%' }" appendTo="body">
    </p-multiSelect>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="modal-footer">
      <button type="button" class="modal-btn-cancel" (click)="showImportTemplateDialog = false">Cancel</button>
      <button type="button" class="modal-btn-primary" (click)="onImportComplete()">Import</button>
    </div>
  </ng-template>
</p-dialog>

<!-- ===== Preview Dialog ===== -->
<p-dialog [(visible)]="showPreviewDialog" [modal]="true"
  styleClass="preview-dialog kansei-dialog"
  [style]="{ width: '70rem', height: '80vh' }" [contentStyle]="{ 'overflow-y': 'auto' }">
  <ng-template pTemplate="header">
    <div class="flex align-items-center justify-content-between w-full">
      <span class="font-semibold text-xl">Template Preview</span>
      <button type="button" class="preview-pdf-btn" (click)="downloadPdf()" [disabled]="isGeneratingPdf">
        @if (isGeneratingPdf) {
          <i class="ri-loader-4-line ctrl-spin"></i>
        } @else {
          <i class="ri-download-line"></i>
        }
        Export PDF
      </button>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <div id="preview-print-content" class="print-content">
      <div class="print-header mb-3 p-3 border-1 surface-border border-round">
        <h2 class="m-0 mb-2">{{ template.templateName }}</h2>
        <p class="text-500 m-0">{{ template.description }}</p>
      </div>
      <ng-template #previewSectionTemplate let-sect="section" let-level="level">
        <div class="preview-panel" [class.preview-panel--sub]="level > 0" [class.preview-panel--open]="sect.isExpanded">
          <div class="preview-panel-hdr" (click)="sect.isExpanded = !sect.isExpanded">
            <button class="preview-toggle-btn" type="button" (click)="$event.stopPropagation(); sect.isExpanded = !sect.isExpanded">
              <i [class]="sect.isExpanded ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
            </button>
            <div class="preview-panel-info">
              <span class="preview-panel-name">{{ sect.sectionName }}</span>
              @if (sect.description) {
                <span class="preview-panel-desc">{{ sect.description }}</span>
              }
            </div>
          </div>
          @if (sect.isExpanded) {
            <div class="preview-panel-body">
              @for (child of getSectionChildren(sect); track $index) {
                @if (child.type === 'lineItem') {
                  <div class="preview-line-item">
                    @if (asLineItem(child).controlTypeId !== undefined && asLineItem(child).controlTypeId !== null) {
                      @if (asLineItem(child).controlTypeId === ControlType.TextBox) {
                        <app-textbox-control [lineItem]="asLineItem(child)"
                          [value]="getPreviewValue(asLineItem(child).lineItemId)"
                          (valueChange)="setPreviewValue(asLineItem(child).lineItemId, $event)" />
                      }
                      @if (asLineItem(child).controlTypeId === ControlType.TextArea) {
                        <app-textarea-control [lineItem]="asLineItem(child)"
                          [value]="getPreviewValue(asLineItem(child).lineItemId)"
                          (valueChange)="setPreviewValue(asLineItem(child).lineItemId, $event)" />
                      }
                      @if (asLineItem(child).controlTypeId === ControlType.CheckBox) {
                        <app-checkbox-control [lineItem]="asLineItem(child)"
                          [value]="getPreviewValue(asLineItem(child).lineItemId)"
                          (valueChange)="setPreviewValue(asLineItem(child).lineItemId, $event)" />
                      }
                      @if (asLineItem(child).controlTypeId === ControlType.Select) {
                        <app-select-control [lineItem]="asLineItem(child)"
                          [options]="asLineItem(child).lineItemOptionValueList || []"
                          [value]="getPreviewValue(asLineItem(child).lineItemId)"
                          (valueChange)="setPreviewValue(asLineItem(child).lineItemId, $event)" />
                      }
                      @if (asLineItem(child).controlTypeId === ControlType.ImpactedArea) {
                        <app-select-control [lineItem]="asLineItem(child)"
                          [options]="asLineItem(child).lineItemOptionValueList || []"
                          [multiple]="true"
                          [value]="getPreviewValue(asLineItem(child).lineItemId)"
                          (valueChange)="setPreviewValue(asLineItem(child).lineItemId, $event)" />
                      }
                      @if (asLineItem(child).controlTypeId === ControlType.DatePicker) {
                        <app-datepicker-control [lineItem]="asLineItem(child)"
                          [value]="getPreviewValue(asLineItem(child).lineItemId)"
                          (valueChange)="setPreviewValue(asLineItem(child).lineItemId, $event)" />
                      }
                      @if (asLineItem(child).controlTypeId === ControlType.DateTimePicker) {
                        <app-datetimepicker-control [lineItem]="asLineItem(child)"
                          [value]="getPreviewValue(asLineItem(child).lineItemId)"
                          (valueChange)="setPreviewValue(asLineItem(child).lineItemId, $event)" />
                      }
                      @if (asLineItem(child).controlTypeId === ControlType.Table) {
                        <app-table-control [lineItem]="asLineItem(child)" [projectId]="0"
                          [value]="getPreviewValue(asLineItem(child).lineItemId)"
                          (valueChange)="setPreviewValue(asLineItem(child).lineItemId, $event)" />
                      }
                      @if (asLineItem(child).controlTypeId === ControlType.Attachment) {
                        <app-attachment-control [lineItem]="asLineItem(child)"
                          [value]="getPreviewValue(asLineItem(child).lineItemId)"
                          (valueChange)="setPreviewValue(asLineItem(child).lineItemId, $event)" />
                      }
                      @if (asLineItem(child).controlTypeId === ControlType.Picture) {
                        <app-picture-control [lineItem]="asLineItem(child)"
                          [value]="getPreviewValue(asLineItem(child).lineItemId)"
                          (valueChange)="setPreviewValue(asLineItem(child).lineItemId, $event)" />
                      }
                      @if (asLineItem(child).controlTypeId === ControlType.Signature) {
                        <app-signature-control [lineItem]="asLineItem(child)"
                          [value]="getPreviewValue(asLineItem(child).lineItemId)"
                          (valueChange)="setPreviewValue(asLineItem(child).lineItemId, $event)" />
                      }
                      @if (asLineItem(child).controlTypeId === ControlType.DigitalSignature) {
                        <app-digitalsignature-control [lineItem]="asLineItem(child)"
                          [value]="getPreviewValue(asLineItem(child).lineItemId)"
                          (valueChange)="setPreviewValue(asLineItem(child).lineItemId, $event)" />
                      }
                      @if (asLineItem(child).controlTypeId === ControlType.QRScanner) {
                        <app-qrscanner-control [lineItem]="asLineItem(child)"
                          [value]="getPreviewValue(asLineItem(child).lineItemId)"
                          (valueChange)="setPreviewValue(asLineItem(child).lineItemId, $event)" />
                      }
                      @if (asLineItem(child).controlTypeId === ControlType.Weather) {
                        <app-weather-control [lineItem]="asLineItem(child)"
                          [value]="getPreviewValue(asLineItem(child).lineItemId)"
                          (valueChange)="setPreviewValue(asLineItem(child).lineItemId, $event)" />
                      }
                      @if (asLineItem(child).controlTypeId === ControlType.RichText) {
                        <app-richtext-control [lineItem]="asLineItem(child)"
                          [value]="getPreviewValue(asLineItem(child).lineItemId)"
                          (valueChange)="setPreviewValue(asLineItem(child).lineItemId, $event)" />
                      }
                      @if (asLineItem(child).controlTypeId === ControlType.LabelText) {
                        <app-labeltext-control [lineItem]="asLineItem(child)" />
                      }
                      @if (asLineItem(child).controlTypeId === ControlType.Skids) {
                        <app-skids-control [lineItem]="asLineItem(child)"
                          [projectId]="0"
                          [value]="getPreviewValue(asLineItem(child).lineItemId)"
                          (valueChange)="setPreviewValue(asLineItem(child).lineItemId, $event)" />
                      }
                      @if (asLineItem(child).controlTypeId === ControlType.Decimal) {
                        <app-decimal-control [lineItem]="asLineItem(child)"
                          [value]="getPreviewValue(asLineItem(child).lineItemId)"
                          (valueChange)="setPreviewValue(asLineItem(child).lineItemId, $event)" />
                      }
                      @if (asLineItem(child).controlTypeId === ControlType.Integer) {
                        <app-integer-control [lineItem]="asLineItem(child)"
                          [value]="getPreviewValue(asLineItem(child).lineItemId)"
                          (valueChange)="setPreviewValue(asLineItem(child).lineItemId, $event)" />
                      }
                    }
                  </div>
                } @else {
                  <ng-container *ngTemplateOutlet="previewSectionTemplate; context: {section: asSubsection(child), level: level + 1}"></ng-container>
                }
              }
            </div>
          }
        </div>
      </ng-template>
      @for (sect of sections; track $index) {
        <ng-container *ngTemplateOutlet="previewSectionTemplate; context: {section: sect, level: 0}"></ng-container>
      }
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="modal-footer">
      <button type="button" class="modal-btn-cancel" (click)="showPreviewDialog = false">Close</button>
    </div>
  </ng-template>
</p-dialog>

